"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLanguagesEnum = exports.AvailableEventsEnum = exports.MiscellaneousEventsEnum = exports.DeviceNotificationsKindEnum = exports.SceneNotificationsKindEnum = void 0;
exports.SceneNotificationsKindEnum = {
    EVENT_SCENE_WARNING: 'EVENT_SCENE_WARNING',
    EVENT_SCENE_SUCCESS: 'EVENT_SCENE_SUCCESS',
    EVENT_SCENE_FAILED: 'EVENT_SCENE_FAILED',
};
exports.DeviceNotificationsKindEnum = {
    EVENT_DEVICE_MISSING: 'EVENT_DEVICE_MISSING',
};
exports.MiscellaneousEventsEnum = {
    EVENT_MESSAGE: 'EVENT_MESSAGE',
    EVENT_RELEASE: 'EVENT_RELEASE',
};
exports.AvailableEventsEnum = {
    ...exports.SceneNotificationsKindEnum,
    ...exports.DeviceNotificationsKindEnum,
    ...exports.MiscellaneousEventsEnum,
};
exports.NotificationLanguagesEnum = {
    it: 'it',
    en: 'en',
};
